/**
 * @description
 * @author: 菩萨蛮
 * @date 2020/9/16 5:06 下午
 * @version V1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行
 */

import TableFactory from './factory/TableFactory';
import NewFactory from './factory/NewFactory';
import ModifyFactory from './factory/ModifyFactory';

const OrderFactory = Object.create(null);


const orderInit = {
  table: TableFactory,
  new: NewFactory,
  modify: ModifyFactory
};

OrderFactory.install = Vue => {
  Vue.mixin({
    data() {
      if (this.$options === undefined) {
        // 为了避免this.$options.data()引发的undefined问题，但是会丢失obj
        return {};
      }
      const { qx, ts } = this.$options;
      if (qx !== undefined) {
        const data = new orderInit[qx.pageType](qx.order);
        return data.initData();
      }
      if (ts !== undefined) {
        const data = new orderInit[ts.pageType](ts.order);
        return data.initData();
      }
      return {};
    }
  });
};


export default OrderFactory;
